import { Component } from '@angular/core';
import { first } from 'rxjs/operators';

import { User } from '../../_models/user';
// import { UserService} from '../../_services/user.service';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {
    loading = false;
    currentUser: User;
    // userFromApi = [];

    constructor(
        // private userService: UserService,
        private authenticationService: AuthenticationService
    ) {
        this.currentUser = this.authenticationService.currentUserValue;
        console.log(this.currentUser);
    }

    ngOnInit() {
        this.loading = true;
        // this.userFromApi = this.currentUser['data'];
        // console.log(this.userFromApi);
        
    }
}